import * as React from 'react';
import { toast } from '@grandvisionhq/common';
import { useMutation } from '@grandvisionhq/graphql';
import { useIntl } from '@grandvisionhq/state';
import { logSocialLoginEvent } from '../../data-layer/social-login.js';
import { ACTIVATE_SOCIAL_ACCOUNT } from '../../operations/mutations/activate-social-account.js';
import { REQUEST_SOCIAL_LOGIN_MERGE } from '../../operations/mutations/request-social-login-merge.js';
import { SocialLoginModal } from './SocialLoginModal.js';

const SocialLoginModalContainer = ({ parseHash  })=>{
    const [email, setEmail] = React.useState('');
    const [showModal, setShowModal] = React.useState(false);
    const { getLabel , getFormattedLabel  } = useIntl();
    const labels = {
        socialLoginError: getLabel('account.socialModal.socialLoginError'),
        mergeAccountError: getLabel('account.socialModal.mergeAccountError'),
        modalTitle: getLabel('account.socialModal.modalTitle'),
        modalText: getFormattedLabel('account.socialModal.modalText', {
            labelData: {
                email
            },
            parseHTML: true
        }),
        yes: getLabel('account.socialModal.button.mergeAccounts'),
        no: getLabel('account.socialModal.button.keepAccountsSeparate')
    };
    const [activateSocialAccount] = useMutation(ACTIVATE_SOCIAL_ACCOUNT, {
        onCompleted (data) {
            logSocialLoginEvent({
                type: 'sign_in_google_successful'
            });
            /**
       * This mutation responds with accounts related to the current account.
       */ const hasAdditionalAccounts = Boolean(data.activateSocialAccount.mergeableAccounts.length);
            if (hasAdditionalAccounts) {
                /**
         * Show modal to merge accounts when related accounts are present and mergeable.
         */ logSocialLoginEvent({
                    type: 'merge_account_modal_view'
                });
                setShowModal(true);
                setEmail(data.activateSocialAccount.mergeableAccounts[0].email);
            } else {
                continueParseHash();
                setEmail('');
            }
        },
        onError () {
            toast.failed(labels.socialLoginError);
            setEmail('');
        }
    });
    React.useEffect(()=>{
        activateSocialAccount();
    /* Just trigger this useEffect once to execute the mutation when this modal mounts. */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const continueParseHash = ()=>{
        /**
     * This strips ?loginMethod="social" from the URL, so that we do not show the option to merge again.
     */ const qp = new URLSearchParams(window.location.search);
        qp.delete('loginMethod');
        const nextUrl = `${window.location.pathname}${qp.toString()}${window.location.hash}`;
        window.location.replace(nextUrl);
        setShowModal(false);
        parseHash();
    };
    const [requestSocialLoginMerge, { loading: mergeLoading , error: mergeError  }] = useMutation(REQUEST_SOCIAL_LOGIN_MERGE, {
        onCompleted: ()=>{
            logSocialLoginEvent({
                type: 'merge_account_success'
            });
            continueParseHash();
        },
        onError: (err)=>{
            logSocialLoginEvent({
                type: 'merge_account_error',
                errorMessage: err.message
            });
        }
    });
    return /*#__PURE__*/ React.createElement(SocialLoginModal, {
        isOpen: showModal,
        labels: labels,
        onCancel: ()=>{
            logSocialLoginEvent({
                type: 'merge_account_click',
                action: 'separated'
            });
            continueParseHash();
        },
        onCta: ()=>{
            logSocialLoginEvent({
                type: 'merge_account_click',
                action: 'merged'
            });
            requestSocialLoginMerge();
        },
        isCtaLoading: mergeLoading,
        errorMessage: mergeError === null || mergeError === void 0 ? void 0 : mergeError.message
    });
};

export { SocialLoginModalContainer };
//# sourceMappingURL=SocialLoginModalContainer.js.map
